// Custom template references ("custom:<id>" from the admin's template editor,
// "usercustom:<id>" from a business's own Templates page) resolve to names
// server-side on the rows that carry them: templateName, and templateKind
// ("admin" or "business"). This turns such a row into what a label prints:
// the template's name with a note on who made it, or the maker alone when
// the template is gone or the row predates the lookup. Built-in style ids
// (template-a, ats...) are not custom and return null: callers keep their
// own style names for those.
export function customTemplateDisplay(row, { yours = false } = {}) {
  const ref = String((row && row.template) || "");
  const kind = (row && row.templateKind) || (ref.startsWith("usercustom:") ? "business" : ref.startsWith("custom:") ? "admin" : null);
  if (!kind) return null;
  const maker = kind === "business" ? (yours ? "Your design" : "Business design") : "MintSlip template";
  const name = row && row.templateName;
  return name ? { label: name, note: maker } : { label: maker, note: null };
}

// One string for a table cell or CSV: "Acme Stub · Business design", or the
// maker alone as the fallback.
export function customTemplateText(row, opts) {
  const c = customTemplateDisplay(row, opts);
  if (!c) return null;
  return c.note ? `${c.label} · ${c.note}` : c.label;
}
